<style></style>
<template>
  <div class="rechargeMsg-box">
    <div class="shade-box">
      <div class="shade-content">
        <p class="dialog-title-bg">短信充值
          <button type="button" aria-label="Close" class="el-dialog__headerbtn"   @click="closeRecharge('rechargeForm')"><i class="el-icon-circle-close-outline"></i></button></p>
        <div class="el-dialog__body">
          <el-form :model="rechargeMsgForm" :rules="$rules" ref="rechargeForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="充值用户：">
              <p>{{this.rechargeData.userName}}</p>
            </el-form-item>
            <el-form-item label="当前可以额度：">
              <p>{{this.rechargeData.smsBalanceSize}}</p>
            </el-form-item>
            <el-form-item label="充值额度" prop="rechargeNum">
              <el-input v-model="rechargeMsgForm.rechargeNum" placeholder="请输入短信充值额度" ref="input" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item class="marginTop30">
              <el-button type="primary paddingTB7" @click="submitForm('rechargeForm')" :disabled="disabled">确认充值</el-button>
              <el-button @click="closeRecharge('rechargeForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../server/api.js'
export default {
  props: {
    rechargeData: {
      type: Object
    }
  },
  name: "rechargeMsg",
  data(){
    return{
      disabled: false,
      rechargeMsgForm: {
        rechargeNum: ''//短信充值额度
      },
    };
  },
  created(){
    this.$nextTick(function(){
      this.$refs.input.focus();
    })
  },
  methods: {
    submitForm(formName){//充值
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.disabled = true;
          let data = {
            "payItemType": 2,//富信
            "overplus": this.rechargeMsgForm.rechargeNum,//模板内容
            "targerUserId": this.rechargeData.userId,//模板申请原因
          }
          api.updateSmsBalanceSize({data:data}).then(res =>{
            if(res.status == 'success'){
              this.$message.success(res.msg)
              this.$emit('rechargeClose')
            }else{
              this.disabled = false;
            }
          })
        } else {
          return false;
        }
      });
    },
    closeRecharge(formName){//取消
      this.$refs[formName].resetFields();
      this.$emit('rechargeClose')
    }
  },
  components: {
    
  }
}
</script>
  




// WEBPACK FOOTER //
// src/components/customer/rechargeMsg.vue